import { useQuery } from '@tanstack/react-query';
import restClient from '../common/api/restClient';

export const useSkillDimensionsByJobProfile = (jobProfileId) => {
    const prefix = process.env.REACT_APP_PROXY_PREFIX || '';
    return useQuery({
        queryKey: ['skillDimensions', jobProfileId],
        queryFn: async () => {
            const result = await restClient({ url: `${prefix}/skill-dimensions/job-profile/${jobProfileId}` });
            return result;
        },
        enabled: !!jobProfileId,
        staleTime: 5 * 60 * 1000
    });
};
